import { ReactNode } from 'react';
import { Box, Heading, Divider } from '@chakra-ui/react';
import { FlexRow } from 'components/layout/FlexRow';

const panelStyle = {
  width: '100%',
};

const titleStyle = {
  display: 'inline-flex',
  mb: 'padding_8',
  gap: 'padding_8',
};

const dividerStyle = {
  borderColor: '#CCD1CC',
  borderWidth: '1px',
  marginY: 'padding_8',
};

interface PanelProps {
  title: string;
  icon?: ReactNode;
  titleTag?: ReactNode;
  children: ReactNode;
}

export const Panel = ({ title, icon, titleTag, children }: PanelProps) => {
  return (
    <Box sx={panelStyle}>
      <FlexRow sx={titleStyle}>
        <Box>{icon}</Box>
        <Heading sx={{ fontSize: '20px', fontWeight: 600 }}>{title}</Heading>
        {titleTag && <Box>{titleTag}</Box>}
      </FlexRow>
      <Divider sx={dividerStyle} />
      {children}
    </Box>
  );
};
